import { memo } from 'react'
import { Tooltip } from '@/components/ui'
import { cn } from '@/lib/utils'

interface ActionButtonProps {
  icon: React.ElementType
  tooltip: string
  onClick?: () => void
  variant?: 'default' | 'danger'
}

/**
 * Small icon button with tooltip for asset card actions.
 */
export const ActionButton = memo(function ActionButton({ 
  icon: Icon, 
  tooltip, 
  onClick, 
  variant = 'default' 
}: ActionButtonProps) {
  return (
    <Tooltip title={tooltip} position="top" align="center">
      <button
        onClick={onClick}
        className={cn(
          "p-2 rounded-md transition-colors",
          variant === 'danger'
            ? "text-red-400/60 hover:text-red-400 hover:bg-red-500/10"
            : "text-[#666] hover:text-white hover:bg-white/[0.05]"
        )}
      >
        <Icon className="size-[18px]" />
      </button>
    </Tooltip>
  )
})
